import {
    buttonClassName,
    pxToRem,
    labelClassName,
    dropdownClassName,
    dropdownSortSlotClassNames,
    pxArrayToRem,
    dropdownItemSlotClassNames,
    dropdownItemClassName,
    dropdownSlotClassNames,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { FILTER_BAR_HEIGHT } from '~/modules/design-board/config';

export const BaseStyle: StyleRule = ({ theme }) => ({
    [theme.screen.min.tablet]: {
        alignItems: 'center',
        padding: pxArrayToRem([0, 48, 0, 48]),
        minHeight: pxToRem(FILTER_BAR_HEIGHT),
        borderBottom: '1px solid #EAEAEA', // color can not find in aria
    },
    minHeight: pxToRem(325),
    justifyContent: 'space-between',
    width: '100%',

    [theme.screen.clamped]: {
        padding: 0,
    },
});

export const Header: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        fontSize: pxToRem(18),
        letterSpacing: theme.siteVariables.letterSpacingSmall,
    },
});

export const FilterBarButtons: StyleRule = ({ theme, isAllPins = false }) => ({
    [theme.screen.tablet]: {
        columnGap: pxToRem(30),

        [`& > .${buttonClassName}`]: {
            height: pxToRem(44),
            [`& > .${labelClassName}`]: {
                fontSize: pxToRem(14),
            },
        },

        [`& .${dropdownClassName}`]: {
            paddingTop: pxToRem(3),
            marginRight: isAllPins ? pxToRem(15) : pxToRem(7),
            [`& .${dropdownSortSlotClassNames.currentItem}`]: {
                order: 1,
                fontSize: pxToRem(14),
            },
            [`& .${dropdownSlotClassNames.selectedItems}`]: {
                [`& .${svgIconClassName}`]: {
                    order: 2,
                    width: pxToRem(10),
                    height: pxToRem(10),
                    margin: pxArrayToRem([0, 0, 0, 9]),
                    '&.expanded': {
                        transform: 'rotate(180deg)',
                        marginTop: pxToRem(-3),
                    },
                },
            },
            [`& .${dropdownSlotClassNames.itemsList}`]: {
                [`& .${dropdownItemClassName}`]: {
                    width: pxToRem(239),
                    padding: pxToRem(8),
                    [`& .${svgIconClassName}`]: {
                        width: pxToRem(16),
                        height: pxToRem(16),
                    },
                },
            },
            [`& .${dropdownItemSlotClassNames.header}`]: {
                fontSize: pxToRem(16),
                lineHeight: 1,
            },
            '& .disabled': {
                cursor: 'default',
                [`& .${dropdownItemSlotClassNames.header}`]: {
                    color: theme.siteVariables.colors.grey[100],
                },
            },

            [`& .${dropdownItemClassName}`]: {
                '&[aria-selected="true"]': {
                    background:
                        theme.siteVariables.colors.transparency.black['6%'],
                },
            },
        },

        [`& > .${buttonClassName}:last-child`]: {
            height: pxToRem(44),
            paddingRight: pxToRem(20),
            width: pxToRem(150),

            [`& > .${labelClassName}`]: {
                fontSize: pxToRem(14),
                letterSpacing: theme.siteVariables.letterSpacingSmall,
                whiteSpace: 'nowrap',
            },

            '& > span': {
                padding: 0,
                marginRight: pxToRem(6),
                [`& > .${svgIconClassName}`]: {
                    width: pxToRem(20),
                    height: pxToRem(20),
                },
            },
        },
    },
});
